export default "__VITE_ASSET__BLM2FzI6__"